import React, { useEffect, useState } from "react"
import API from "../../api/axios"
import AdminLayout from "./AdminLayout"

const AdminEnrollments = () => {
  const [enrollments, setEnrollments] = useState([])
  const [loading, setLoading]         = useState(true)
  const [error, setError]             = useState("")

  useEffect(() => {
    API.get("/enrollments")
      .then(res => setEnrollments(res.data.data))
      .catch(() => setError("Failed to load enrollments."))
      .finally(() => setLoading(false))
  }, [])

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-KE", { day: "numeric", month: "short", year: "numeric" }) : "-"

  return (
    <AdminLayout title="Enrolments">
      {error && <div className="admin-alert admin-alert-error">{error}</div>}

      <div className="admin-section">
        <div className="admin-section-header">
          <h3>All Enrolments ({enrollments.length})</h3>
        </div>

        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Student</th>
                <th>Course</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Enrolled</th>
                <th>Completed</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr className="admin-loading-row">
                  <td colSpan="7"><i className="fa fa-spinner fa-spin"></i> Loading…</td>
                </tr>
              )}
              {!loading && enrollments.length === 0 && (
                <tr><td colSpan="7" className="admin-empty">No enrolments yet.</td></tr>
              )}
              {!loading && enrollments.map((e, i) => (
                <tr key={e.id}>
                  <td style={{ color: "#aaa" }}>{i + 1}</td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{e.user?.name}</div>
                    <small style={{ color: "#999" }}>{e.user?.email}</small>
                  </td>
                  <td>{e.course?.title}</td>
                  <td><span className={`badge badge-${e.status}`}>{e.status}</span></td>
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <div className="mini-bar">
                        <div className="mini-fill" style={{ width: `${e.percentComplete}%` }}></div>
                      </div>
                      <span style={{ fontSize: 12, color: "#666" }}>{e.percentComplete}%</span>
                    </div>
                  </td>
                  <td style={{ fontSize: 12, color: "#888" }}>{fmtDate(e.createdAt)}</td>
                  <td style={{ fontSize: 12, color: "#888" }}>{e.completedAt ? fmtDate(e.completedAt) : <span style={{ color: "#ccc" }}>—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  )
}

export default AdminEnrollments
